import { useContext } from "react";
import AuthContext from "../store/auth-cxt";

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
